import GridTabs from 'common/components/grid/GridTabs'
import { generateKey } from 'common/utils/uuid'
import { t } from 'i18next'
import { useDispatch, useSelector } from 'react-redux'
import { updateModel, deleteTab } from 'model/saga-actions/modelActions'
import { selectTab } from 'model/store/modelReducer'
import AssetViews from 'common/screens/asset/AssetViews'
import { PRODUCTS } from 'common/constants/products'

export default function ModelTabs({ aid, isDesigning }) {
	const dispatch = useDispatch()

	// #### REDUX
	const tid = useSelector((state) => state.auth.tid)
	const teamId = useSelector((state) => state.team.teamId)
	const tabs = useSelector((state) => state.model.model[aid]?.data?.tabs)
	const tabIndex = useSelector((state) => state.model.tabIndex[aid]) || 0

	function onSelectTab(tabIndex) {
		dispatch(selectTab({ id: aid, tabIndex }))
	}

	function onCreateTab() {
		const newTab = { id: generateKey(6), name: t('common:defaults.newTab'), groups: [] }
		const newTabs = tabs ? [...tabs, newTab] : [newTab]
		dispatch(updateModel({ tid, aid, content: { tabs: newTabs } }))
	}

	function onRenameTab(value, index) {
		if (!(value?.length > 0) || tabs[index] === value) return
		var newTabs = [...tabs]
		newTabs[index] = { ...tabs[index], name: value }
		dispatch(updateModel({ tid, aid, content: { tabs: newTabs } }))
	}

	function onDeleteTab(tabIndex) {
		dispatch(deleteTab({ tid, teamId, aid, tabIndex }))
	}

	function onMoveTab(dragIndex, dropIndex) {
		const tab = tabs[dragIndex]
		var newTabs = [...tabs]
		const shift = dragIndex < dropIndex ? 1 : 0
		newTabs.splice(dragIndex, 1)
		newTabs.splice(dropIndex - shift, 0, tab)
		dispatch(updateModel({ tid, aid, content: { tabs: newTabs } }))
	}

	return (
		<GridTabs
			tabs={tabs}
			activeTab={tabIndex}
			isDesigning={isDesigning}
			onSelect={onSelectTab}
			onCreate={onCreateTab}
			onRename={onRenameTab}
			onDelete={onDeleteTab}
			onMove={onMoveTab}
			rightContent={<AssetViews aid={aid} product={PRODUCTS.model.key} />}
		/>
	)
}
